"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeTimeCode", {
  enumerable: true,
  get: function get() {
    return _timeCodeHelpers.makeTimeCode;
  }
});
exports.default = void 0;

require("@babel/polyfill");

var _streamController = _interopRequireDefault(require("./stream-controller"));

var _manson = _interopRequireDefault(require("@krad/manson"));

var _timeCodeHelpers = require("./time-code-helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var plainview =
/*#__PURE__*/
function () {
  function plainview(config) {
    _classCallCheck(this, plainview);

    _manson.default.setup();

    this.stream = new _streamController.default(config); /// Stub out everything with no operations until the user configures them

    var NOP = function NOP() {};

    this.onCanPlay = NOP;
    this.onPlayProgress = NOP;
    this.onDownloadProgress = NOP;
    this.onPlay = NOP;
    this.onPlaying = NOP;
    this.onPause = NOP;
    this.onSuspend = NOP;
    this.onWaiting = NOP;
    this.onReplay = NOP;
    this.onMute = NOP;
    this.onUnmute = NOP;
    this.onEnded = NOP;
    this.onStall = NOP;
    this.onError = NOP;
  }

  _createClass(plainview, [{
    key: "setLogLevel",
    value: function setLogLevel(val) {
      _manson.default.level = val;
    }
  }, {
    key: "play",
    value: function play() {
      _manson.default.info('user pressed play');

      this.video.play();
    }
  }, {
    key: "replay",
    value: function replay() {
      _manson.default.info('user pressed replay');

      this.video.play();
      this.onReplay();
      this.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      _manson.default.info('user pressed paused');

      this.video.pause();
    }
  }, {
    key: "mute",
    value: function mute() {
      _manson.default.info('user pressed mute');

      this.video.muted = true;
      this.onMute();
    }
  }, {
    key: "unmute",
    value: function unmute() {
      _manson.default.info('user pressed unmute');

      this.video.muted = false;
      this.onUnmute();
    }
  }, {
    key: "requestFullScreen",
    value: function requestFullScreen() {
      _manson.default.info('user pressed fullscreen');

      if (this.video.requestFullscreen) {
        this.video.requestFullscreen();
      } else if (this.video.mozRequestFullScreen) {
        this.video.mozRequestFullScreen(); // Firefox
      } else if (this.video.webkitRequestFullscreen) {
        this.video.webkitRequestFullscreen(); // Chrome and Safari
      }
    }
  }, {
    key: "video",
    get: function get() {
      return this._video;
    },
    set: function set(val) {
      var _this = this;

      this._video = val;
      this.mute(); // videos need to be muted for autoplay to start

      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('autoplay', 'true');
      this.video.addEventListener('timeupdate', function (e) {
        _manson.default.trace("timeupdate event: ".concat(e));

        var progress = (0, _timeCodeHelpers.percentageComplete)(_this.video.currentTime, _this.stream.totalDuration);
        var timecode = (0, _timeCodeHelpers.makeTimeCode)(_this.video.currentTime);
        var total = (0, _timeCodeHelpers.makeTimeCode)(_this.stream.totalDuration);

        _this.onPlayProgress(progress, timecode, total);
      });
      this.video.addEventListener('canplay', function () {
        _manson.default.trace('player canplay event');

        _this.onCanPlay();
      });
      this.video.addEventListener('ended', function (e) {
        _manson.default.trace('player ended event');

        _this.onEnded();
      });
      this.video.addEventListener('pause', function () {
        _manson.default.trace('player pause event');

        _this.onPause();
      });
      this.video.addEventListener('suspend', function () {
        _manson.default.trace('player suspend event');

        _this.onSuspend();
      });
      this.video.addEventListener('play', function () {
        _manson.default.trace('player play event');

        _this.onPlay();
      });
      this.video.addEventListener('playing', function () {
        _manson.default.trace('player playing event');

        _this.onPlaying();
      });
      this.video.addEventListener('stalled', function (e) {
        _manson.default.trace("player stalled event ".concat(JSON.stringify(e)));

        _this.onStall();
      });

      this.video.onwaiting = function () {
        _manson.default.trace('player waiting event');

        _this.onWaiting();
      };

      this.video.addEventListener('error', function (e) {
        _manson.default.trace("player error event ".concat(e));

        console.log(e);

        _this.onError();
      });
      this.runLoop = this.stream.start(this.video).then(function (_) {
        _manson.default.info('Reached end of stream');

        _this.onEnded();
      }).catch(function (err) {
        return _manson.default.error("problem starting player: ".concat(err));
      });
    }
  }, {
    key: "onDownloadProgress",
    set: function set(cb) {
      if (this.stream) {
        this.stream.onDownloadProgress = cb;
      }
    }
  }]);

  return plainview;
}();

var _default = plainview; //       this.player.configure().then(player => {
//         Manson.debug('player configured')
//         // const timecode  = makeTimeCode(this.video.currentTime)
//         // const total     = makeTimeCode(this.player.totalDuration)
//         // this.onPlayProgress(0, timecode, total)2
//
//

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/distribution/plainview.js
// module id = 156
// module chunks = 0